import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--surface-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: var(--surface-1);
  padding: 20px;
  border-radius: 8px;
  max-width: 800px;
  width: 90%;
  max-height: 80%;
  overflow-y: auto;
  box-shadow: var(--shadow-md);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.4rem;
  font-weight: bold;
`;

export const CloseButton = styled.button`
  background: var(--danger);
  color: var(--text-primary);
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    background: var(--danger);
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

export const Th = styled.th`
  border: 1px solid var(--border-default);
  padding: 8px;
  background: var(--table-header-bg);
  color: var(--table-header-color);
  font-weight: var(--table-header-font-weight);
  font-size: var(--table-header-font-size);
  text-transform: uppercase;
  letter-spacing: var(--table-header-letter-spacing);
  text-align: left;
`;

export const Td = styled.td`
  border: 1px solid var(--border-default);
  padding: 8px;
  font-size: 0.95rem;
`;
